import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const EmailVerificationGuard = ({ children }: { children: React.ReactNode }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Don't redirect if still loading or not authenticated
    if (loading || !isAuthenticated || !user) {
      return;
    }

    // Don't redirect if already on verification page or auth pages
    const publicPaths = ['/login', '/signup', '/verify-email', '/forgot-password', '/reset-password'];
    if (publicPaths.includes(location.pathname)) {
      return;
    }

    // If user is logged in but email is not verified, redirect to verification page
    // Only redirect if not already on the verification page
    if (user && !user.emailVerified && location.pathname !== '/verify-email') {
      navigate('/verify-email', {
        replace: true,
        state: { email: user.email, from: location.pathname }
      });
    }
  }, [user, loading, isAuthenticated, navigate, location.pathname]);

  return <>{children}</>;
};

export default EmailVerificationGuard;

